module.exports = __webpack_public_path__ + "static/benefit-3-c38eb83e5b903578c2ad9f11d72b8ced.svg";